// utils/chatModerationApi.js
// Batch chat moderation for institute admins: the report queue and the mutes it
// produces. Reporting and blocking are done by chat members from the mobile app.
import apiClient from './apiClient';

/** @param {{ status?: string, page?: number, pageSize?: number }} params  status is a comma list */
export const getChatReports = (params) => apiClient.get('/chat/reports', { params });

/** @param {'remove' | 'remove_and_mute' | 'dismiss'} action */
export const resolveChatReport = (reportId, action) =>
  apiClient.patch(`/chat/reports/${reportId}`, { action });

export const getChatMutes = () => apiClient.get('/chat/mutes');

export const unmuteChatMember = (userId) => apiClient.delete(`/chat/mutes/${userId}`);
